const i = (e) => Array.isArray(e) && e.length > 0 ? e[0] : null, r = (e, n) => {
  let t = e;
  for (; t.parentNode && t.parentNode.tagName !== "BODY"; )
    n(t), t = t.parentNode;
}, s = (e) => {
  const n = [];
  return r(e, (t) => {
    window.getComputedStyle(t).position === "fixed" && n.push(t);
  }), n;
}, d = (e = []) => e.reduce((n, t) => {
  const o = parseInt(getComputedStyle(t).zIndex) || 1;
  return Math.max(n, o);
}, 1);
export {
  i as first,
  r as forEachParent,
  s as getFixedPositionParents,
  d as getMaxZIndex
};
